import i18n from '../i18n';
import paymentCardApi from '../api/paymentCardApi';
import { actions as notificationActions } from './notificationActions';
import * as logger from '../utils/logger';

export const types = {
  GET_PAYMENT_CARD: 'GET_PAYMENT_CARD',
  GET_PAYMENT_CARD_SUCCESS: 'GET_PAYMENT_CARD_SUCCESS',
  GET_PAYMENT_CARD_FAILURE: 'GET_PAYMENT_CARD_FAILURE',
  START_PAYMENT_CARD_ACTIVATION: 'START_PAYMENT_CARD_ACTIVATION',
  START_PAYMENT_CARD_ACTIVATION_SUCCESS: 'START_PAYMENT_CARD_ACTIVATION_SUCCESS',
  START_PAYMENT_CARD_ACTIVATION_FAILURE: 'START_PAYMENT_CARD_ACTIVATION_FAILURE',
  RESUME_PAYMENT_CARD_ACTIVATION: 'RESUME_PAYMENT_CARD_ACTIVATION',
  RESUME_PAYMENT_CARD_ACTIVATION_SUCCESS: 'RESUME_PAYMENT_CARD_ACTIVATION_SUCCESS',
  RESUME_PAYMENT_CARD_ACTIVATION_FAILURE: 'RESUME_PAYMENT_CARD_ACTIVATION_FAILURE',
  DEACTIVATE_PAYMENT_CARD: 'DEACTIVATE_PAYMENT_CARD',
  DEACTIVATE_PAYMENT_CARD_SUCCESS: 'DEACTIVATE_PAYMENT_CARD_SUCCESS',
  DEACTIVATE_PAYMENT_CARD_FAILURE: 'DEACTIVATE_PAYMENT_CARD_FAILURE',
};

const getFailureMessage = (response, fallbackKey) => {
  const failure = response && response.data && response.data.failure;
  return failure
    ? i18n.t(failure.errorCode, failure.metadata)
    : i18n.t(fallbackKey);
};

export const actions = {
  load: () => dispatch => {
    dispatch({ type: types.GET_PAYMENT_CARD });
    return paymentCardApi
      .get()
      .then(response => {
        if (response.ok) {
          return dispatch({ type: types.GET_PAYMENT_CARD_SUCCESS, data: response.data });
        }

        dispatch({ type: types.GET_PAYMENT_CARD_FAILURE });
        dispatch(notificationActions.showError(i18n.t('wallet.paymentCard.actions.loadFailure')));
        return logger.error(response);
      });
  },

  startActivation: () => dispatch => {
    dispatch({ type: types.START_PAYMENT_CARD_ACTIVATION });
    return paymentCardApi
      .createActivationVerification()
      .then(response => {
        if (response.ok && response.data && response.data.paymentUrl) {
          dispatch({ type: types.START_PAYMENT_CARD_ACTIVATION_SUCCESS });
          window.location.href = response.data.paymentUrl;
          return response.data;
        }

        dispatch({ type: types.START_PAYMENT_CARD_ACTIVATION_FAILURE });
        dispatch(notificationActions.showError(getFailureMessage(response, 'wallet.paymentCard.actions.activationFailure')));
        return logger.error(response);
      });
  },

  resumeActivation: () => dispatch => {
    dispatch({ type: types.RESUME_PAYMENT_CARD_ACTIVATION });
    return paymentCardApi
      .resumeActivationVerification()
      .then(response => {
        if (response.ok && response.data && response.data.paymentUrl) {
          dispatch({ type: types.RESUME_PAYMENT_CARD_ACTIVATION_SUCCESS });
          window.location.href = response.data.paymentUrl;
          return response.data;
        }

        dispatch({ type: types.RESUME_PAYMENT_CARD_ACTIVATION_FAILURE });
        dispatch(notificationActions.showError(getFailureMessage(response, 'wallet.paymentCard.actions.resumeActivationFailure')));
        return logger.error(response);
      });
  },

  deactivate: () => dispatch => {
    dispatch({ type: types.DEACTIVATE_PAYMENT_CARD });
    return paymentCardApi
      .deactivate()
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.DEACTIVATE_PAYMENT_CARD_SUCCESS });
          dispatch(notificationActions.showSuccess(i18n.t('wallet.paymentCard.actions.deactivateSuccess')));
          return dispatch(actions.load());
        }

        dispatch({ type: types.DEACTIVATE_PAYMENT_CARD_FAILURE });
        dispatch(notificationActions.showError(getFailureMessage(response, 'wallet.paymentCard.actions.deactivateFailure')));
        return logger.error(response);
      });
  },
};
